import { encerrar_no_letivo_por_aluno } from "./encerrar-ano-letivo-por-aluno";
import { encerrar_o_ano_letivo_das_turmas_e_gerar_o_historico_escolar_dos_alunos } from "./encerrar-o-ano-letivo-das-turmas-e-gerar-o-historico-escolar-dos-alunos";

const encerrar_ano_letivo_lanca_historico = [
  ...encerrar_no_letivo_por_aluno,
  ...encerrar_o_ano_letivo_das_turmas_e_gerar_o_historico_escolar_dos_alunos,
];

export { encerrar_ano_letivo_lanca_historico };
